<template>

    <div class=" bg-dark vh-100 d-flex">
        <div class="container d-flex align-items-center justify-content-center ">
            <div class="card text-center w-75 h-75">
                <div class="card-header">
                    LICENSE
                </div>
                <div class="card-body" dir="rtl">
                    <!-- <h4 class="card-title">Card Title</h4> -->
                    <div class="d-flex justify-content-center mb-3">
                        <div class="badge" v-if="message.length > 0"
                            :class="[isSuccess ? ['badge-success'] : ['badge-danger']]">
                            {{ message }}
                        </div>
                    </div>
                    <label for="">فایل لایسنس</label>
                    <input type="file" class="form-control" id="inputAttachment">

                    <router-link :to="{ name: 'Login' }" class="btn btn-danger mx-2 w-25 mt-3">
                        صفحه ورود
                    </router-link>
                    <button class="btn btn-primary mt-3 w-25" @click="submit()">
                        ثبت
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Card from '@/components/Card/Card.vue'
export default {
    components: { Card },

    data() {
        return {
            message: '',
            isSuccess: false, 
        }
    },

    methods: {
        submit() {
            let input = document.getElementById('inputAttachment')
            let attachment = document.getElementById('inputAttachment').files[0]
            if (attachment != undefined) {
                if (Math.round(attachment.size / 1000 > 10100)) {
                    this.$mySweetDefaultTost('', 'حجم فایل پیوست باید کمتر از 10 مگ باشد', 'info', 2000)
                    return
                }
            }

            let formData = new FormData()
            formData.append('File', attachment)

            let DataaxiosDepUser = {
                Action: 'license/Submitlicense',
                Method: 'POST',
                ArryfildValue: formData,
            }

            this.$PostFormData(DataaxiosDepUser).then((result) => {
                this.isSuccess = result.status
                this.message = result.message
                input.value = ""
            }).catch((err) => {
                console.error('CATCH', err)
                input.value = ""
                if(err.response.status == 401){
                    this.message = "جهت لایسنس ابتدا وارد شوید"
                }
            })

        }
    },
}

</script>

<style scoped>

</style>